import { Form } from '@ferreri/prever-component-lib';
import * as yup from 'yup';

import { LocationSearchInput } from './LocationSearchInput';

const locationSearchSchema = yup.object().shape({
  address: yup.string().min(3, 'Digite pelo menos 3 caracteres.').required(),
});

type LocationSearchFormProps = {
  setIsSearching: (isSearching: boolean) => void;
  setAddress: (address: string) => void;
  isSearching: boolean;
};

export const LocationSearchForm = (props: LocationSearchFormProps) => {
  return (
    <Form schema={locationSearchSchema}>
      <LocationSearchInput
        setIsSearching={props.setIsSearching}
        setAddress={props.setAddress}
        isSearching={props.isSearching}
      />
    </Form>
  );
};
